module.exports = __webpack_public_path__ + "img/max-file-content-image-configure.4d593819.svg";